import { mdiCheck } from '@mdi/js';
import * as React from 'react';
import * as S from './checkbox.styles';

export interface IBaseCheckboxProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type'> {
    label?: string;
    type?: 'checkbox';
    variant?: 'small' | 'medium' | 'large';
}

export class BaseCheckbox extends React.Component<IBaseCheckboxProps> {
    public render(): React.ReactElement {
        const { className, checked, label, variant, disabled, ...props } = this.props;
        const checkboxVariant: 'small' | 'medium' | 'large' = variant ?? 'medium';

        return (
            <S.CheckboxContainer className={className} checked={checked} disabled={disabled}>
                <S.HiddenCheckbox checked={checked} disabled={disabled} {...props} />
                <S.StyledCheckbox variant={checkboxVariant}>
                    <S.CheckIcon path={mdiCheck} />
                </S.StyledCheckbox>
                {label && <S.Label variant={checkboxVariant}>{label}</S.Label>}
            </S.CheckboxContainer>
        );
    }
}
